import { render } from "./OurMission.vue?vue&type=template&id=7c7a9af4&scoped=true"
import script from "./OurMission.vue?vue&type=script&lang=js"
export * from "./OurMission.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7c7a9af4"

export default script